import {FeaturesEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';

export function useHealthNetworkVisibility() {
	const {isHAP} = useHostName();
	const bookingData = useBookingStore(state => state.bookingData);
	const {isEnabled: accreditedNetworkHAPSPRJFlagIsEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_HAPVIDA_SP_RJ_ACCREDITED_NETWORK,
	);

	const isSPOrRJ = ['SP', 'RJ'].includes(bookingData.ufCode?.toUpperCase());

	const showAccreditedNetworkToHap = accreditedNetworkHAPSPRJFlagIsEnabled && isHAP && isSPOrRJ;

	return {
		showAccreditedNetworkToHap,
	};
}
